import { render, staticRenderFns } from "./s1.vue?vue&type=template&id=11c0efec&scoped=true&"
var script = {}
import style0 from "./s1.vue?vue&type=style&index=0&id=11c0efec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c0efec",
  null
  
)

export default component.exports